export { TopNav } from "./TopNav";
export { TopTabs } from "./TopTabs";
export { TopBanner } from "./Banner";
export { DetailOne } from "./DetailPage1";
export { Slider } from "./Slider";
export { ImgBlocks } from "./ImgBlocks";
export { MultipleTabs } from "./MultipleTabs";
export { ServiceBlock } from "./ServiceBlock";
export { PressBlock } from "./PressBlock";
export { FooterBlock } from "./FooterBlock";

